module.exports = __webpack_public_path__ + "img/chabao.c404d603.png";